'use strict';

import * as model from './model.js';
import gridView from './views/subViews/gridView.js';
import worksheetView from './views/subViews/worksheetView.js';
import relatedItemsView from './views/subViews/relatedItemsView.js';

import gridContainer from './views/containerViews/gridContainerView.js';
import workSheetContainer from './views/containerViews/WorkSheetContainerView.js';
import relatedItemsPaginationView from './views/subViews/relatedItemsPaginationView.js';

import * as helper from './helper.js';

const displayWorkSheet = async function () {
	//1. Get the sheetId
	const sheetId = helper.getSheetId();
	//2. load data
	await model.loadSheetData(sheetId);

	//3. load related items data
	if (model.state.sheetData.relatedItemsIds)
		await model.loadRelatedItemsData(model.state.sheetData.relatedItemsIds);
	else model.state.relatedItems.items = [];
	//4. render worksheet data
	workSheetContainer.prepareContainer();

	initWorkSheetContainer();

	worksheetView.render(model.state.sheetData);

	//5. render relatedItems
	if (model.state.relatedItems.items.length) {
		relatedItemsView.render(model.getRelatedItemsPage(1)); //model.state.relatedItems
		relatedItemsPaginationView.render(model.state.relatedItems);
	}
};
const displayGrid = async function () {
	try {
		//1. Get the JsonId of the
		const jsonID = helper.getJsonId();

		if (!jsonID) return;

		//2. load data
		await model.loadGridData(jsonID);

		//3. render data
		gridContainer.prepareContainer();

		gridView.render(model.state.gridData);
	} catch (err) {
		console.error(err);
	}
};

const updateRelatedItemsView = function (page) {
	relatedItemsView.render(model.getRelatedItemsPage(page));
	relatedItemsPaginationView.render(model.state.relatedItems);
};

const initWorkSheetContainer = function () {
	relatedItemsPaginationView.addHandlerClick(updateRelatedItemsView);
};

//Handle Events through Publisher-Subscriber Pattern
const init = function () {
	gridView.addhandlerRendrer(handleHashChange);
	model.state.relatedItems.itemsPerPage = helper.calculatePageSize();
	// relatedItemsPaginationView.addHandlerClick(updateRelatedItemsView);
};

const handleHashChange = function () {
	helper.isGridView() ? displayGrid() : displayWorkSheet();
};

const handleWindowResize = function () {
	model.state.relatedItems.itemsPerPage = helper.calculatePageSize();
	updateRelatedItemsView(1);
};
window.addEventListener('resize', handleWindowResize);
init();
